module.exports = __webpack_public_path__ + "img/patent-org.1807aa9d.png";